module.exports = __webpack_public_path__ + "static/media/statpro-revolution.2f691357.png";